<template>
  <div :class="{inject: inject}">
    <div
      v-if="srItem"
      :class="{ 'grey lighten-5': !$vuetify.theme.dark }"
    >
      <table class="calcTable">
        <tr>
          <td style="width: 90px">
            包裹體積
          </td>
          <td>
            <v-layout
              align-center
              class="ma-0 inputWrap"
            >
              <input
                v-model="form.length"
                placeholder="長"
              >
              <input
                v-model="form.width"
                placeholder="寬"
              >
              <input
                v-model="form.height"
                placeholder="高"
              >
              <div>
                /CM
              </div>
            </v-layout>
          </td>
        </tr>
        <tr>
          <td>
            包裹重量<span
              class="red--text"
              style="display: inline-block;width: 10px"
            >*</span>
          </td>
          <td>
            <v-layout
              align-center
              class="ma-0 inputWrap"
            >
              <input
                v-model="form.weight"
                placeholder="重量"
              >
              <div>
                /KG
              </div>
              <v-spacer />
            </v-layout>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <v-layout
              align-center
              class="ma-0 inputWrap"
            >
              <v-checkbox
                v-model="isCalcWoodenFee"
                class="mt-0 pt-0"
                hide-details
              >
                <div
                  slot="label"
                  style="font-size: 14px;"
                >
                  計算打木架/木箱費用
                </div>
              </v-checkbox>
              <v-spacer />
              <v-btn
                round
                small
                color="info"
                class="ma-0"
                @click="startCalc"
              >
                預估運費
              </v-btn>
            </v-layout>
          </td>
        </tr>
        <template v-if="calcForm.weight">
          <tr
            v-if="srItem.transport === 'air' && calcForm.volWeight > calcForm.weight"
          >
            <td>體積重量</td>
            <td>
              <b>{{ calcForm.volWeight | toKg }}KG</b>
              <div class="caption grey--text">
                {{ calcForm.length }}*{{ calcForm.width }}*{{ calcForm.height }}/6000={{ calcForm.volWeight | toKg }}KG
              </div>
            </td>
          </tr>
          <tr v-if="srItem.transport === 'air' ">
            <td>計費重量</td>
            <td>
              <b>{{ computerSettlementWeight(calcForm.chgWeight,srItem.minWeight, true, srItem.transport) | toKg }}KG</b>
              <span class="ml-2">普/特貨同價</span>
              <div
                v-if="calcForm.volWeight > calcForm.weight"
                class="caption grey--text"
              >
                {{ calcForm.volWeight | toKg }}-優惠{{ calcForm.volWeight-calcForm.chgWeight | toKg }}={{ calcForm.chgWeight | toKg }}KG
              </div>
            </td>
          </tr>
          <tr v-if="srItem.transport === 'se' ">
            <td>計費重量</td>
            <td>
              <b>{{ computerSettlementWeight(calcForm.weight,srItem.minWeight, true, srItem.transport) | toKg }}KG</b>
              <div class="caption grey--text">
                不足{{ srItem.minWeight | toKg }}KG按{{ srItem.minWeight | toKg }}KG計重
              </div>
            </td>
          </tr>
          <tr v-if="srItem.transport === 'sea' ">
            <td>計費重量</td>
            <td>
              <b>{{ computerSettlementWeight(calcForm.weight,srItem.minWeight, true, srItem.transport) | toKg }}KG</b>
              <div class="caption grey--text">
                不足{{ srItem.minWeight | toKg }}KG按{{ srItem.minWeight | toKg }}KG計重
              </div>
            </td>
          </tr>
          <tr>
            <td>預估費用</td>
            <td>
              <div><b class="red--text headline mr-1">{{ parcelsFee | toTwb }}</b>元</div>
              <div class="grey--text caption">
                <div
                  v-if="srItem.firstWeight > 0 && srItem.addlWeight > 0"
                >
                  <div v-if="settlementWeight > 1000">
                    {{ srItem.fwFee }}元首重*1KG={{ computerParcelFee(1000,srItem.fwFee) | toTwb }}元<br>
                    {{ srItem.awFee }}元續重*{{ (settlementWeight-1000)/1000 }}KG={{ $calc.mul((settlementWeight-1000)/1000,srItem.awFee) | toTwb }}元
                  </div>
                  <div v-else>
                    {{ srItem.fwFee }}元首重*1KG
                  </div>
                </div>
                <!-- 首重 -->
                <div
                  v-else-if="srItem.firstWeight > 0"
                >
                  （{{ $calc.add(addFee, srItem.fwFee) }}元/KG*{{ settlementWeight / 1000 }}KG={{ parcelsFee | toTwb }}元）
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="hctCaiFee && srItem.transport !== 'sea'">
            <td>
              新竹超才費<Tooltips><HctCaiFeeText /></Tooltips>
            </td>
            <td>
              <b class="red--text  mr-1">{{ hctCaiFee }}</b>元
            </td>
          </tr>
          <tr v-if="isCalcWoodenFee && woodenFee[0]">
            <td>打木架</td>
            <td>
              <b class="red--text  mr-1">{{ woodenFee[0] }}</b>元
            </td>
          </tr>
          <tr v-if="isCalcWoodenFee && woodenFee[0]">
            <td>打木箱</td>
            <td>
              <b class="red--text  mr-1">{{ woodenFee[1] }}</b>元
            </td>
          </tr>
          <template v-if="srItem.transport !== 'sea'">
            <tr v-if="volumeLimitAir(limitCalcItem)">
              <td
                colspan="2"
                class="red--text"
              >
                物品單邊長度不可超過160cm，空運三邊若兩邊超過 70cm 和 85cm 需要轉一般倉正式報關，會產生移倉費、倉租費、稅金等等費用(新台幣$4700起)，會實報實銷由派件公司代取，正式報關需要提供委任書、賣方資料(姓名/地址/電話)、下單畫面。
              </td>
            </tr>
            <tr v-if="weightLimitAir(limitCalcItem)">
              <td
                colspan="2"
                class="red--text"
              >
                空運單件70KG以上包裹需要轉一般倉正式報關，會產生移倉費、倉租費、稅金等等費用(新台幣$4700起)，會實報實銷由派件公司代取，正式報關需要提供委任書、賣方資料(姓名/地址/電話)、下單畫面。
              </td>
            </tr>
            <tr v-if="weightLimitSe(limitCalcItem)">
              <td
                colspan="2"
                class="red--text"
              >
                海快單件70KG以上包裹需要轉一般倉正式報關，會產生移倉費、倉租費、稅金等等費用，無法事先預估，會實報實銷由派件公司代取，正式報關需要提供委任書、賣方資料(姓名/地址/電話)、下單畫面。
              </td>
            </tr>
            <tr v-else-if="volumeLimitSe(limitCalcItem)">
              <td
                colspan="2"
                class="red--text"
              >
                海快單件物品限制長寬高：180cm*180cm*長不限，重量超過70kg或是尺寸三邊有其中兩邊超過180cm無法通過海關x光機，需要轉一般倉正式報關，時效慢且會產生新台幣3-6千高額雜費，稅金另計，費用為實報實銷。
              </td>
            </tr>
            <tr v-else-if="volumeLimitSeBy1210">
              <td
                colspan="2"
                class="red--text"
              >
                上海倉海快單件包裹尺寸 三邊其中兩邊超過110cm 需走一般倉正式報關，建議寄至其他海快倉。
              </td>
            </tr>
            <tr v-if="suggestTips(limitCalcItem) === 'UnilateralLimit'">
              <td
                colspan="2"
                class="orange--text"
              >
                提醒您，該包裹單邊長超過90cm，若合併打包在運輸途中極容易丟失或損壞，故需要單獨打包或與其他單邊長超過90cm的物品合包，巧巧郎關心您～
              </td>
            </tr>
            <tr v-if="isLongAndThin(limitCalcItem)">
              <td
                colspan="2"
                class="orange--text"
              >
                細長件與其他規格包裹合併下單極易折斷或丟失，因此只能與同為細長件的包裹合併打包或單獨打包。
              </td>
            </tr>
            <tr v-if="hctHatPalletFee(limitCalcItem)">
              <td
                colspan="2"
              >
                <HctHatPalletFeeText />
              </td>
            </tr>
          </template>

          <tr>
            <td colspan="2">
              <div class="subTitle mb-2">
                支持派件方式
                <v-menu
                  offset-y
                >
                  <template #activator="{ on }">
                    <v-btn
                      flat
                      icon
                      small
                      color="info lighten-2"
                      class="ma-0"
                      v-on="on"
                    >
                      <v-icon small>
                        help
                      </v-icon>
                    </v-btn>
                  </template>
                  <div>
                    <v-card class="light-blue lighten-5">
                      <v-card-text>
                        <div>
                          <div>
                            <b>支持派件方式</b>
                          </div>
                          <div>
                            超商<br>
                            1. 長+寬+高≦105公分<br>
                            2. 單邊長≦45公分、其他兩邊≦30公分<br>
                            3. 重量10公斤以內<br>
                          </div>
                          <div class="mt-2">
                            黑貓<br>
                            尺寸在120公分以下（長+寬+高三邊合計），20公斤以內。
                          </div>
                          <div class="mt-2">
                            新竹<br>
                            無限制
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-menu>
              </div>
              <div class="py-2 pl-2  caption">
                <template
                  v-if="srItem.transport !== 'sea'"
                >
                  <v-layout
                    v-if="srItem.transport === 'air'"
                    :class="{limit:volumeLimitCs(limitCalcItem)||weightLimitCs(limitCalcItem)}"
                    class="carrierItem py-2 px-2 ma-0"
                    align-center
                  >
                    <img
                      src="/static/images/carrier/711.png"
                      width="16"
                      class="mr-1"
                    >
                    <div>
                      超商
                    </div>
                    <v-flex class="text-xs-center detailText">
                      <div v-if="volumeLimitCs(limitCalcItem)">
                        體積過超商限制(45cm*30cm*30cm)
                      </div>
                      <div v-if="weightLimitCs(limitCalcItem)">
                        重量超過超商限制(10kg)
                      </div>
                      <div class="canUse">
                        可使用
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-if="srItem.transport === 'air'"
                    :class="{limit:volumeLimitTcat(limitCalcItem)||weightLimitTcat(limitCalcItem)}"
                    class="carrierItem py-2 px-2 mt-2 ma-0"
                    align-center
                  >
                    <img
                      src="/static/images/carrier/tcat.png"
                      width="18"
                      class="mr-1"
                    >
                    <div>
                      黑貓
                    </div>
                    <v-flex class="text-xs-center detailText">
                      <div v-if="volumeLimitTcat(limitCalcItem)">
                        體積過黑貓限制(長+寬+高≤120公分)
                      </div>
                      <div v-if="weightLimitTcat(limitCalcItem)">
                        重量超過黑貓限制(20kg)
                      </div>
                      <div class="canUse">
                        可使用
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    class="carrierItem py-2 px-2 mt-2 ma-0"
                    align-center
                  >
                    <img
                      src="/static/images/carrier/hct.png"
                      width="16"
                      class="mr-1"
                    >
                    <div>
                      新竹
                    </div>
                    <v-flex class="text-xs-center detailText">
                      <div class="canUse">
                        可使用
                      </div>
                    </v-flex>
                  </v-layout>
                </template>

                <v-layout
                  v-if="srItem.transport === 'sea'"
                  class="carrierItem py-2 px-2 mt-2 ma-0"
                  align-center
                >
                  <div>
                    呼力捷
                  </div>
                  <v-flex class="text-xs-center detailText">
                    <div class="canUse">
                      可使用
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import calc from 'calculatorjs'
import HctHatPalletFeeText from '@g/components/Text/HctHatPalletFeeText'
import {
  computeFeeBySrItemAndWeight,
  computerParcelFee,
  computerSettlementWeight
} from '@g/utils/orderUtils'
import {
  volumeLimitAir,
  weightLimitAir,
  volumeLimitSe,
  weightLimitSe,
  singleMaxVolume,
  calcWoodenFeeByLuo,
  volumeLimitCs,
  weightLimitCs,
  volumeLimitTcat,
  weightLimitTcat,
  calcHctCai,
  hctHatPalletFee,
  isLongAndThin,
  suggestTips,
} from '@g/utils/parcelUtils'
// import CalcFee from './components/CalcFee'
// import SrIcon from './components/SrIcon'
export default {
  components: {
    HctHatPalletFeeText,
    // CalcFee,
    // SrIcon,
  },
  props: {
    srItem: Object,
    inject: Boolean,
  },
  data () {
    return {
      tabIndex: '',
      srList: [],
      srid: '',
      computerSettlementWeight,
      computerParcelFee,
      computeFeeBySrItemAndWeight,
      form: {
        weight: '',
        width: '',
        height: '',
        length: '',
      },
      calcForm: {},

      volumeLimitAir,
      weightLimitAir,
      volumeLimitSe,
      weightLimitSe,
      volumeLimitCs,
      weightLimitCs,
      volumeLimitTcat,
      weightLimitTcat,
      hctHatPalletFee,
      isLongAndThin,
      suggestTips,

      singleMaxVolume,
      isCalcWoodenFee: true,
    }
  },
  computed: {
    volumeLimitSeBy1210 () {
      return volumeLimitSe({ ...this.limitCalcItem, jyAddrid: '1210' })
    },
    settlementWeight () {
      let chgWeight = this.calcForm.chgWeight
      if (this.srItem.transport === 'se' || this.srItem.transport === 'sea') {
        chgWeight = this.calcForm.weight
      }
      return computerSettlementWeight(chgWeight, this.srItem.minWeight, true, this.srItem.transport)
    },
    hctCaiFee () {
      const cai = calcHctCai(this.limitCalcItem)
      if (cai > 6) {
        return Math.ceil(cai - 6) * 25
      }
      return 0
    },
    addFee () {
      const srItem = this.srItem
      if (!srItem) return 0
      let addFee = 0
      let viewFeeType = ''
      if (srItem.transport === 'air') {
        viewFeeType = this.$store.state.shippingRate.viewAirFeeType
      } else if (srItem.transport === 'se') {
        viewFeeType = this.$store.state.shippingRate.viewSeFeeType
      }
      if (viewFeeType === 'tax') {
        addFee = srItem.taxFee || 0
      } else if (viewFeeType === 'frt') {
        addFee = srItem.frtFee || 0
      }
      return addFee
    },
    parcelsFee () {
      const srItem = this.srItem
      const settlementWeight = this.settlementWeight
      if (srItem.firstWeight > 0 && srItem.addlWeight > 0) {
        if (settlementWeight > 1000) {
          return Math.floor(calc(`${srItem.fwFee} + ${settlementWeight / 1000 - 1} * ${this.$calc.add(srItem.awFee, this.addFee)}`))
        } else {
          return calc(`${settlementWeight / 1000} * ${srItem.fwFee}`)
        }
      } else {
        return calc(`${settlementWeight / 1000} * ${this.$calc.add(srItem.fwFee, this.addFee)}`)
      }
    },
    limitCalcItem () {
      return {
        weight: this.calcForm.weight,
        width: Number(this.calcForm.width) * 10,
        height: Number(this.calcForm.height) * 10,
        length: Number(this.calcForm.length) * 10,
      }
    },
    woodenFee () {
      return calcWoodenFeeByLuo(this.limitCalcItem)
    },
  },
  watch: {},
  async mounted () {
    // 普特貨價格一樣，過濾掉特貨
    this.srList = this.$store.state.jyShippingRatesSource.filter(item => !(item.transport === 'air' && item.type === 'twt'))
    this.srid = this.srList[0].srid
  },
  methods: {
    async startCalc () {
      const f = {
        ...this.form,
        weight: calc(`${this.form.weight}*1000`),
        volWeight: 0,
        chgWeight: calc(`${this.form.weight}*1000`),
      }
      if (f.width > 0 && f.height > 0 && f.length > 0) {
        f.volWeight = calc(`${f.width}*${f.height}*${f.length}/6000*1000`)
        if (f.volWeight > f.weight * 3) {
          f.chgWeight = calc(`${f.volWeight}/2`)
        }
      }

      this.calcForm = f

      // const res = await this.$store.dispatch('jyb/shippingRate/calc', {
      //   ...this.form
      // })

      // console.dir(res.data)
    },
  }
}
</script>
<style lang="postcss" scoped>
.inputWrapTr {
  > *:nth-child(1){
    width: 100px;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    padding: 10px 0;
  }
  > *:nth-child(2){
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    padding: 10px 0;
    flex: 1;
    padding: 0 10px;
  }
  input {
    text-align: center;
    width: 50px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-right: 5px;
    outline: none;
  }
}
</style>

<style lang="postcss" scoped>
.calcTable {
  border: 0;
  border-collapse: collapse;
  width: calc(100% + 1px);
  text-align: left;
  line-height: 1.2;
  th,
  td {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 6px 5px;
  }
}
.inputWrap {
  input {
    text-align: center;
    width: 40px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-right: 3px;
    outline: none;
    border-radius: 5px;
    line-height: 22px;
  }
}
.inject {
}

.carrierItem {
  border: 1px solid green;
  border-radius: 5px;;
  img {
    vertical-align: middle;
  }
  .canUse {
    color: green;
  }
  &.limit {
    border: 1px solid red;
    .canUse {
      display: none;
    }
  }
}
</style>
